<template>
  <div class="ui-mygallery-curaion-grid" role="list">
    <BaseLayoutGrid>
        <div
          v-for="item in itemList"
          class="grid-item jps-card"
          role="listitem"
          :key="item.id"
        >
          <div v-if="item.id" class="ui-mygallery-curation-card">
            <div class="jps-card-img" aria-hidden="true">
              <BaseLink
                class="card-image"
                to="/mygallery/view"
                @click="selectGallery(item)"
              >
                <UiImageSelection :image="item.image" type="curation" image-usage="thumbnail" />
              </BaseLink>
            </div>
            <div class="jps-card-body">
              <h2 class="jps-card-title">
                <BaseLink
                  class="card-image"
                  to="/mygallery/view"
                  @click="selectGallery(item)"
                >
                  {{ ls(item.title) }}
                </BaseLink>
              </h2>
              <p class="is-size-7">{{ ls(item.responsibility) }}</p>
              <p class="jps-card-content">{{ ls(item.summary) }}</p>
            </div>
            <div class="cur-tools">
              <BaseLink
                to="/mygallery/edit"
                @click="selectGallery(item)"
              >
                <BaseIcon name="mdi/pencil" />
                {{ ls({ ja: '編集', en: 'Edit' }) }}</BaseLink
              >
              <BaseLink
                to="/mygallery/view"
                @click="selectGallery(item)"
              >
                <BaseIcon name="mdi/eye" />
                {{ ls({ ja: 'プレビュー', en: 'Preview' }) }}</BaseLink
              >
              <BaseDropdown position="bottom-left">
                <template #trigger="">
                  <button class="jps-icon-button">
                    <BaseIcon name="mdi/dots-horizontal" />
                  </button>
                </template>
                <BaseDropdownItem @click="deleteGallery(item)">{{
                  lss('削除', 'Delete')
                }}</BaseDropdownItem>
              </BaseDropdown>
            </div>
          </div>
          <div v-else class="add-gallery">
            <div class="add-gallery-options">
              <BaseRadio v-model="_addGalleryMode" native-value="new">{{ lss('新しいページを作成', 'Create a new page') }}</BaseRadio>
              <BaseRadio v-model="_addGalleryMode" native-value="template">{{ lss('テンプレートから作成', 'Create from template') }}</BaseRadio>
            </div>
            <button
              class="jps-button jps-button-with-left-icon add-gallery-button"
              @click="addGallery()"
            >
              <BaseIcon name="mdi/plus-circle" />
              {{ lss('ページを追加', 'Add page') }}
            </button>
          </div>
        </div>
    </BaseLayoutGrid>
  </div>
</template>

<script lang="ts" setup>
const { ls, lss } = useI18n()

interface Props {
  curations: Curation[]
  addGalleryMode: 'new' | 'template'
}
const props = withDefaults(defineProps<Props>(), {})
const emit = defineEmits(['select-gallery', 'delete-gallery', 'add-gallery', 'change-add-gallery-mode'])

const _addGalleryMode = computed({
  get: () => props.addGalleryMode,
  set: (value: string) => {
    emit('change-add-gallery-mode', value)
  },
})

const itemList = computed(() => {
  if (props.curations) {
    let list = clone(props.curations)
    list.push({} as Curation)
    return list
  } else {
    return [{} as Curation]
  }
})

const selectGallery = (item: Curation) => {
  emit('select-gallery', item)
}

const deleteGallery = (item: Curation) => {
  emit('delete-gallery', item.id)
}

const addGallery = () => {
  emit('add-gallery')
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.ui-mygallery-curaion-grid {
  min-height: 24rem;
}
.jps-card {
  border: 1px solid $jps-gray-300;
  border-radius: 0.5rem;
  height: 400px;
  @include transition-all;

  &:hover {
    background: $white;
  }
  .jps-card-body {
    flex-grow: 1;
    margin: 0 .75rem 0;
    .jps-card-title {
      margin-top: 0;
    }
  }

  .ui-mygallery-curation-card {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .cur-tools {
    display: flex;
    gap: 1rem;
    margin: {
      top: auto;
      bottom: 0;
    }
    padding: .75rem;
    justify-content: flex-end;
    font-size: $size-8;
    background: $white;
    border-top: 1px solid $jps-gray-200;
    a {
      display: flex;
      gap: 3px;
      align-items: center;
      font-weight: bold;
    }
  }
}

.add-gallery {
  height: 100%;
  min-height: 250px;
  display: flex;
  padding: 1.5rem;
  gap: 3rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  @include transition-all;

  .add-gallery-options {
    width: auto;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
    margin-left: -.5rem;
  }

  .add-gallery-button {
    width: 100%;
    color: $jps-gray-900;
    &:not(:disabled):hover {
      color: $jps-gray-900;
    }
  }
}
</style>
